import RealTemplate, { type Props } from "@decocms/apps-blog/sections/Template";

// @decocms/apps-blog's Template.tsx renders `post.sections` itself via a
// renderSection() helper that expects the RAW decofile shape
// (`{ __resolveType, ...props }`) — a leftover from the original Deno/Fresh
// app it was ported from. This framework's own block resolver, though,
// already resolves any `__resolveType`-bearing object it walks into the
// POST-resolution shape (`{ Component, props }`) before handing it to a
// section — the same shape @decocms/tanstack's DecoPageRenderer consumes.
// Nothing rejects or logs this mismatch: renderSection() just finds no
// `__resolveType` key, and silently returns null for every block. Adapting
// back to the raw shape here — before it reaches the real Template — is a
// site-local fix, not a node_modules patch.
function toRawResolvable(section: unknown): unknown {
  if (
    section &&
    typeof section === "object" &&
    "Component" in section &&
    !("__resolveType" in section)
  ) {
    const { Component, props } = section as { Component: string; props?: Record<string, unknown> };
    return { __resolveType: Component, ...(props ?? {}) };
  }
  return section;
}

export default function Template({ post }: Props) {
  const adaptedPost = post
    ? { ...post, sections: post.sections?.map(toRawResolvable) }
    : post;
  return <RealTemplate post={adaptedPost} />;
}
